export default __webpack_public_path__ + "static/media/our-vision.37a18d72.png";